module.exports = __webpack_public_path__ + "img/flixbus.9842e9d7.svg";